const Crypto = require("crypto-js");

exports.btoa = function (rawString) {
    return Buffer.from(rawString).toString("base64");
};

exports.atob = function (encodedString) {
    return Buffer.from(encodedString, "base64").toString();
};

exports.generateIdSync = function (count) {
    var _sym = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890"; //abcdefghijklmnopqrstuvwxyz1234567890
    var str = "";

    for (var i = 0; i < count; i++) {
        str += _sym[parseInt(Math.random() * _sym.length)];
    }

    return str;
};

exports.YouTubeGetID = function (url) {
    url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_-]/i)[0] : url[0];
}

exports.lowercaseString = function (str) {
    var AccentsMap = [
        "aàảãáạăằẳẵắặâầẩẫấậ",
        "AÀẢÃÁẠĂẰẲẴẮẶÂẦẨẪẤẬ",
        "dđ", "DĐ",
        "eèẻẽéẹêềểễếệ",
        "EÈẺẼÉẸÊỀỂỄẾỆ",
        "iìỉĩíị",
        "IÌỈĨÍỊ",
        "oòỏõóọôồổỗốộơờởỡớợ",
        "OÒỎÕÓỌÔỒỔỖỐỘƠỜỞỠỚỢ",
        "uùủũúụưừửữứự",
        "UÙỦŨÚỤƯỪỬỮỨỰ",
        "yỳỷỹýỵ",
        "YỲỶỸÝỴ"    
      ];
      for (var i=0; i<AccentsMap.length; i++) {
        var re = new RegExp('[' + AccentsMap[i].substr(1) + ']', 'g');
        var char = AccentsMap[i][0];
        str = str?.replace(re, char);
      }
      return str;
}

exports.getUniqueName = function () {
	return Math.random()
		.toString( 36 )
		.replace( /[^a-z]+/g, '' )
		.substr( 0, 5 );
}

exports.encrypt = (value = '') => Crypto.AES.encrypt(value, 'qrcode-redcode').toString()

exports.decrypt = (value = '') => Crypto.AES.decrypt(value, 'qrcode-redcode').toString(Crypto.enc.Utf8)
